import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../api";
import PageViewer from "../builder/PageViewer";
import HeaderFooterLayout from "../layouts/HeaderFooterLayout";
import styles from "./CoursePreview.module.css";

const CoursePreview = () => {
    const { courseId } = useParams();
    const navigate = useNavigate()
    const [course, setCourse] = useState(null)

    const getCourse = async () => {
        try {
            let course = await api.get(`/admin/courses/${courseId}`)

            setCourse(course)

        }
        catch (e) {

            console.error(e)
            navigate("/404")
        }
    }
    useEffect(() => {
        getCourse()
    }, [courseId])

    useEffect(() => {
        window.scrollTo({
            top: 0,
        })

    }, [])

    return (
        <HeaderFooterLayout hideFooter>
            <div className={styles.container}>
                {course &&
                    <PageViewer page={course.content} />
                }
            </div>

        </HeaderFooterLayout>
    )
}

export default CoursePreview
